export default "__VITE_ASSET__CWpFt6ij__"